import { AbstractControl, ValidatorFn } from '@angular/forms';

export class CustomValidator {
  static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {
    let config = {
      'required': `${validatorValue} is required.`,
      'invalid': `${validatorValue} format is invalid.`,
      'password': `Password has to be at least 8 characters, have a special character and a capital letter.`,
      'package_quantity': 'Please select a quantity for Packages or Pallets',
      'numberRequired': `Please Enter a ${validatorValue}`,
      'maxLength': `${validatorValue} too long`
    };

    return config[validatorName];
  }

  static required(fieldName: string) {
    return (control: AbstractControl) => {
      if (!control.value) {
        return { 'required': fieldName };
      }
      return null;
    }
  }

  //Incorrect Pattern used
  //static email(fieldName: string) {
  //  return (control: AbstractControl) => {
  //    const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  //    if (control.value && !pattern.test(control.value)) {
  //      return { "invalid": fieldName };
  //    }
  //    return null;
  //  }
  //}

  static password(fieldName: string) {
    const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;
    return (control: AbstractControl) => {
      if (control.value && !pattern.test(control.value)) {
        return { 'password': fieldName };
      }
      return null;
    }
  }

  static packageQuantityRequired(palletValue: number) {
    return (control: AbstractControl) => {
      if (!control.disabled && control.value < 1 && palletValue < 1) {
        return { 'package_quantity': true };
      }
      return null;
    }
  }

  static requireForNumber(fieldName: string) {
    return (control: AbstractControl) => {
      if (!control.value) {
        return { 'numberRequired': fieldName };
      }
      return null;
    }
  }

  static maxLength(fieldName: string, max: number) {
    return (control: AbstractControl) => {
      if (control.value && control.value.length > max) {
        return { 'maxLength': fieldName };
      }
      return null;
    }
  }
}
